import axios from "axios";
import { Local_URL } from "assets/constants";

const createBackendServer = (baseURL) => {
    const api = axios.create({
        baseURL: `${baseURL}`,
        withCredentials: true,
        headers: {
            Accept: "application/json"
        },
        timeout: 60 * 1000,
    });

    // Interceptor for adding token to requests
    api.interceptors.request.use(
        (config) => {
            // Retrieve token from localStorage
            const token = localStorage.getItem('x-auth-token');

            // If token exists, add it to the request headers
            if (token) {
                config.headers['x-auth-token'] = token;
                config.headers['x-auth-admin'] = "admin";
            }

            return config;
        },
        (error) => {
            // Handle any request errors here
            return Promise.reject(error);
        }
    );


    //Interceptor
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            const message = error?.response?.data?.message;
            error.message = message ?? error.message
            if (error?.response?.data?.errors)
                error.errors = error?.response?.data?.errors;


            if (error?.response?.status === 401) {
                // window.location.href = "/sp/logout"; 
            }

            return Promise.reject(error)
        })

    const headers = {
        "Content-Type": "multipart/form-data",
    };

    /*==========    INVESTORS APIS    ==========*/
    const investorRegistration = async (body) => api.post('/api/investors/investor', body, { headers });
    const legalInvestorRegistration = async (body) => api.post('/api/investors/legal_investor', body, { headers });

    /*==========    Admin USER APIS    ==========*/

    const getTotalUsersCount = async () => api.get('/api/users/count');


    const deleteUser = async (id) => api.post(`/api/users/delete`, { id });
    const approveUser = async (id) => api.get(`/api/admin/verify/${id}`);
    const disableUser = async (id) => api.get(`/api/admin/disable/${id}`);
    const logoutUser = async () => api.get(`/api/users/logout`);

    /*==========    Admin STORE APIS    ==========*/
    const disableStore = async (id) => await api.put(`/api/store/disable/${id}`)
    const enableStore = async (id) => await api.put(`/api/store/enable/${id}`)

    /*==========    Admin Blog APIS    ==========*/

    const verifyUserDocuments = (id, type, reason) => api.put(`/api/admin/verifiedDocument/${id}?type=${type}`, { reason });

    const updateUserProfile = (id, body) => api.put(`/api/users/profile/${id}`, body);

    const updateUserProfileToken = (id, body) => api.put(`/api/users/profile/notification/${id}`, body);
    const updateAdminProfileToken = (id, body) => api.put(`/api/admin/profile/notification/${id}`, body);


    const disableBlog = async (id) => await api.put(`/api/admin/blogs/disable/${id}`)
    const enableBlog = async (id) => await api.put(`/api/admin/blogs/enable/${id}`)

    const getAllActiveBlog = async () => api.get("/api/admin/blogs/active");

    const adminInvestUser = (id, body) => api.post(`/api/admin/invest/${id}`, body);
    const adminDeleteTransactionUser = (id) => api.get(`/api/admin/invest-rollback/${id}`);
    const getUserReferral = (id) => api.get(`/api/users/referral/${id}`);




    const contactUs = (body) => api.post(`/api/admin/contactUs`, body);

    const getAdminReferral = async () => await api.get('/api/admin/referral');

    const getTotalStoresCount = async () => await api.get('/api/store/count');

    const getAllUser = async ({ search = "", page, limit, category = "", includeDeleted = false } = {}) => {
        const params = new URLSearchParams();

        if (search.trim()) {
            params.set("search", search.trim());
        }

        if (category.trim()) {
            params.set("category", category.trim());
        }

        if (page !== undefined && limit !== undefined) {
            params.set("page", String(page));
            params.set("limit", String(limit));
        }

        if (includeDeleted) {
            params.set("includeDeleted", "true");
        }

        const query = params.toString();
        return api.get(`/api/admin/allUser${query ? `?${query}` : ""}`);
    };
    const getUserOverviewStats = async () => api.get("/api/admin/user-stats");
    const getAllStores = async () => api.get("/api/store/");
    const getAllActiveStores = async () => api.get("/api/store/all");
    const getCountTotalShares = () => api.get('/api/store/countStores');//soon
    const getCountAvailableShares = () => api.get('/api/store/countStores');//soon


    const getUserDocuments = (id) => api.get(`/api/users/documentUpload/${id}`);


    const getAdminProfile = async id => api.get(`/api/admin/profile/${id}`);
    const getAdminStats = async () => api.get("/api/admin/admin-dashboard-stats");
    const getWallet = (id) => api.get(`/api/wallet/${id}`);
    const getProfile = async id => api.get(`/api/users/profile/${id}`);
    const getStore = (id) => api.get(`/api/store/${id}`);
    const getAllStore = async () => await api.get('/api/store');
    const getTotalRecord = async () => await api.get('/api/users/countData');
    const createManualInvestment = async (body) => await api.post('api/invest/manual-invest', body);

    const getRecentUserInvest = async () => await api.get('/api/users/recentUserInvest');
    const getChartData = async () => await api.get('/api/admin/analyticStore');

    const getAnalyticsDataUser = async (id) => await api.get(`/api/users/analytics-app/${id}`);
    const getJourneySummary = async (params = {}) => {
        const query = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                query.set(key, String(value));
            }
        });

        return api.get(`/api/tracking/admin/summary${query.toString() ? `?${query.toString()}` : ""}`);
    };
    const getJourneyEvents = async (params = {}) => {
        const query = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                query.set(key, String(value));
            }
        });

        return api.get(`/api/tracking/admin/events${query.toString() ? `?${query.toString()}` : ""}`);
    };
    const getJourneyFlows = async (params = {}) => {
        const query = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                query.set(key, String(value));
            }
        });

        return api.get(`/api/tracking/admin/flows${query.toString() ? `?${query.toString()}` : ""}`);
    };
    const getTransactions = async (data) => api.get(`/api/transactions?startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data.type}`);
    const getAdminTransactions = async (data) => api.get(`/api/transactions/admin?startDate=${data?.startDate}&endDate=${data?.endDate}`);
    const quoteSharePurchase = async (body) => api.post("/api/share-lots/quote", body);
    const getShareLots = async () => api.get("/api/share-lots");
    const getShareLotReconciliation = async () => api.get("/api/share-lots/admin/reconciliation");
    const expireShareReservations = async (limit = 100) => api.post("/api/share-lots/admin/expire-reservations", { limit });
    const getInvestorShareHoldings = async (userId) => api.get(`/api/share-lots/investors/${userId}/holdings`);
    const getInvestorShares = async (userId, params = {}) => api.get(`/api/share-lots/investors/${userId}/shares`, { params });
    const getUserTransactions = async (id, data = {}) => {
        const params = new URLSearchParams();

        if (data?.startDate) params.set("startDate", data.startDate);
        if (data?.endDate) params.set("endDate", data.endDate);
        if (data?.page !== undefined) params.set("page", String(data.page));
        if (data?.limit !== undefined) params.set("limit", String(data.limit));

        const query = params.toString();
        return api.get(`/api/transactions/${id}${query ? `?${query}` : ""}`);
    };
    const getAdminUserTransactions = async (id, data = {}) => {
        const params = new URLSearchParams();

        if (data?.startDate) params.set("startDate", data.startDate);
        if (data?.endDate) params.set("endDate", data.endDate);
        if (data?.page !== undefined) params.set("page", String(data.page));
        if (data?.limit !== undefined) params.set("limit", String(data.limit));

        const query = params.toString();
        return api.get(`/api/transactions/admin/${id}${query ? `?${query}` : ""}`);
    };
    const getAdminUserProfit = async (id, data = {}) => {
        const params = new URLSearchParams();

        if (data?.startDate) params.set("startDate", data.startDate);
        if (data?.endDate) params.set("endDate", data.endDate);
        if (data?.page !== undefined) params.set("page", String(data.page));
        if (data?.limit !== undefined) params.set("limit", String(data.limit));

        const query = params.toString();
        return api.get(`/api/admin/user-profit/${id}${query ? `?${query}` : ""}`);
    };
    const getAllPopup = async (data) => await api.get(`api/popup/get-all-popup`);
    const getPopupTypes = async (data) => await api.get(`api/popup/popup-types`);
    const createPopup = async (body) => await api.post(`api/popup/create-popup`, body);
    const getPopupbyId = async (id) => await api.get(`/api/popup/get/${id}`);
    const UpdatePopup = async (body) => await api.post(`api/popup/update-popup`, body);
    const DeletePopup = async (id) => await api.delete(`/api/popup/delete-popup/${id}`);
    const getWorldCupBonusState = async () => await api.get('/api/admin/world-cup-bonus');
    const toggleWorldCupBonus = async (body) => await api.put('/api/admin/world-cup-bonus/toggle', body);


    const getDividend = async () => api.get('/api/admin/dividend');
    const getAlltransferShares = async (type) => api.get(`/api/admin/transfer_shares`);
    const getAlltransferTokens = async (type) => api.get(`/api/admin/transfer_jtctokens`);
    const createSecretAdmin = async () => api.get('/api/users/createAdmin?master=fundraiser125%');
    const getAllBlogs = async () => await api.get('/api/admin/blogs');
    const getOneBlog = async (id) => await api.get(`/api/admin/blogs/${id}`);
    const getOneBlogById = async (id) => await api.get(`/api/admin/one-blogs/${id}`);
    const getUserAllDetails = async (id, type) => await api.get(`/api/admin/userAllDetails/${id}?type=${type}`);
    const getUserWithdrawl = async (id) => await api.get(`/api/withdrawl/user/${id}`);
    const getAllWithdrawl = async () => await api.get(`/api/withdrawl`);
    const getAllNewsFeet = async () => await api.get(`/api/admin/news`);
    const getAllWithdrawlAdmin = async () => await api.get(`/api/withdrawl-admin`);

    /*==========    POST REQUESTS    ==========*/

    const createOrder = async (body) => api.post("/api/invest/order", body);

    const adminSendNotification = async (body) => api.post("/api/admin/notification-send", body);
    const submitUserDocuments = async (id, body) => api.post(`/api/users/documentUpload/${id}`, body)

    const resetEmail = async (body) => api.post("/api/admin/reset-email", body);
    const forget = async (body) => api.post("/api/users/forget", body);
    const updatePassword = async (body) => api.post("/api/users/update", body);
    const authLogin = async body => api.post("/api/users/login", body)
    const verification = async (body) => api.post("/api/users/auth-verify", body);
    const kycForm = async (body) => api.post('/api/kyc/create', body, { headers });
    const saveContact = async (body) => api.post('/api/contact', body);
    const adminLogin = async (body) => {
        const response = await api.post("/api/users/admin-login", body);
        const token = response?.data?.token || response?.headers?.["x-auth-token"];
        if (token) localStorage.setItem("x-auth-token", token);
        return response;
    }
    const updateStore = async (body) => api.put(`/api/store`, body, { headers });
    const updateBlog = async ({ blogId, blogData }) => api.put(`/api/admin/blogs/${blogId}`, blogData, { headers });
    const transferShares = async (body) => api.post(`/api/admin/transfer_shares`, body);
    const transferTokens = async (body) => api.post(`/api/admin/transfer_jtctokens`, body);
    const registration = (body, code) => api.post(`/api/users?referralId=${code}`, body, { headers });
    const legalForm = (body) => api.post("/api/users/legal-Form", body, { headers });
    const investNow = (body) => api.post("/api/invest/investor/:id", body);
    const createStore = async (body) => api.post("/api/store", body, { headers });
    const createBlog = async (body) => api.post("/api/admin/blogs", body, { headers });
    const deleteBlogs = async (id) => api.delete("api/admin/blogs", { data: id });
    const deleteStores = async (id) => api.delete(`api/store/delete/${id}`);
    const invest = async (id, body) => api.post(`/api/invest/wallet_invest/${id}`, body)


    const generateLink = async (id) => api.post(`/api/users/referral/${id}`);

    const generateDividend = async (body) => api.post(`/api/invest/generate_dividend`, body);
    const cancelWithdrawl = async (id) => await api.put(`/api/withdrawl/cancel/${id}`);
    const addWithdrawl = async (body) => await api.post(`/api/withdrawl`, body);
    const addWithdrawlAdmin = async (body) => await api.post(`/api/withdrawl-admin`, body);
    const approvedWithdrawl = async (body) => await api.put(`/api/withdrawl/approve`, body);
    const rejectWithdrawl = async (id) => await api.put(`/api/withdrawl/reject/${id}`);
    const addNewsFeet = async (body) => await api.post(`/api/admin/news`, body);
    const userKYC = async (id) => await api.get(`/api/kyc/${id}`);

    const submitSignature = async (id, body) => await api.put(`/api/kyc/sign-contract/${id}`, body);
    const userProfit = async (id) => await api.get(`/api/users/profit/${id}`);

    const getUserNotification = async (id) => await api.get(`/api/users/notification/${id}`);
    const getAdminNotificationRecieve = async (id) => await api.get(`/api/admin/notification/${id}`);


    const seenNotification = async (id) => await api.post(`/api/users/notification-seen/${id}`);


    const seenAdminNotificationHistory = async (id) => await api.post(`/api/admin/notification-seen/${id}`);


    const getAdminNotification = async () => await api.get(`/api/admin/admin-notification`);

    const getSharePriceHistory = async () => await api.get(`/api/admin/share-price-history`);




    const getUserNotificationDetails = async (id) => await api.get(`/api/users/notification/details/${id}`);




    const getAllAnnualProgress = async () => api.get('/api/admin/annual-progress');

    const deleteAnnualProgress = async (id) => api.delete(`api/admin/annual-progress/${id}`);

    const addAnnualProgress = async (body) => api.post('/api/admin/annual-progress', body);

    const sendAnnualProgressReportInvestor = async (body) => api.post('/api/admin/send-annual-progress', body);

    const approvedDocumentsUser = async (id) => await api.post(`/api/admin/user-document-approved/${id}`);
    const disapprovedDocumentsUser = async (id) => await api.post(`/api/admin/user-document-disapproved/${id}`);

    // Shareholder Registry (Legal Compliance) APIs
    const getShareholders = async (params = {}) => api.get('/api/admin/shareholders', { params });

    const getShareholderDetail = async (id) => api.get(`/api/admin/shareholders/${id}`);

    const exportShareholdersCsv = async (params = {}) => api.get('/api/admin/shareholders/export/csv', { params, responseType: 'blob' });

    const exportShareholdersPdf = async (params = {}) => api.get('/api/admin/shareholders/export/pdf', { params, responseType: 'blob' });

    const exportShareholderPdf = async (id) => api.get(`/api/admin/shareholders/${id}/pdf`, { responseType: 'blob' });

    const getAdminTransactionHistory = async (params = {}) => api.get('/api/admin/transaction-history', { params });

    const getJava300Champions = async (params = {}) => api.get('/api/admin/java300/champions', { params });


    //OFFERS APIS ADMIN
    const getAllOffer = async () => api.get("/api/admin/offers");

    const createOffer = async (body) => api.post("/api/admin/offers", body, { headers });

    const getOffer = (id) => api.get(`/api/admin/offers/${id}`);

    const updateOffer = async (body, id) => api.put(`/api/admin/offers/${id}`, body, { headers });

    const disableOffer = async (id) => await api.put(`/api/admin/offers/disable/${id}`)

    const enableOffer = async (id) => await api.put(`/api/admin/offers/enable/${id}`)

    const deleteOffer = async (id) => api.delete(`api/admin/offers/delete/${id}`);

    // Ticket API's

    const createTicket = async (body) => api.post("/api/ticket", body, { headers });
    const getAllTickets = async ({ search = "", page = 1, limit = 10 }) => api.get(`api/ticket/all?search=${search}&page=${page}&limit=${limit}`);
    const getTicketById = async (id) => api.get(`api/ticket/${id}`);
    const updateTicketById = async (body, id) => api.put(`api/ticket/${id}`, body);
    const deleteTicketById = async (id) => api.delete(`api/ticket/${id}`);

    // Phase 1 support chat APIs. These keep all chat state in one backend
    // conversation document while the legacy ticket endpoints remain available.
    const getSupportConversations = async (params = {}) => api.get("/api/support-chat", { params });
    const getSupportConversation = async (id) => api.get(`/api/support-chat/${id}`);
    // Let the browser set multipart/form-data, including its required boundary.
    const sendSupportMessage = async (id, body) => api.post(`/api/support-chat/admin/${id}/messages`, body);
    const updateSupportStatus = async (id, status) => api.patch(`/api/support-chat/${id}/status`, { status });
    const markSupportRead = async (id) => api.post(`/api/support-chat/${id}/read`);
    const startSupportConversation = async (body) => api.post("/api/support-chat/admin-outreach", body);
    const deleteSupportConversation = async (id) => api.delete(`/api/support-chat/${id}`);
    const bulkDeleteSupportConversations = async (payload) => api.delete("/api/support-chat/admin", { data: payload });
    const getSupportAttachment = async (conversationId, messageId) => api.get(`/api/support-chat/${conversationId}/attachments/${messageId}`, { responseType: "blob" });
    const getSupportAccessList = async (params = {}) => api.get("/api/support-chat/admin/access", { params });
    const searchSupportAccessCandidates = async (params = {}) => api.get("/api/support-chat/admin/access/candidates", { params });
    const grantSupportAccess = async (body) => api.post("/api/support-chat/admin/access", body);
    const revokeSupportAccess = async (userId) => api.delete(`/api/support-chat/admin/access/${userId}`);

    const getClaimRequests = async () => api.get(`api/users/get-claim-requests`);

    const manageClaimRequest = async (id, body) => api.patch(`api/users/manage-claim-requests/${id}`, body);

    //Returning all the API
    return {
        getShareholders,
        getShareholderDetail,
        exportShareholdersCsv,
        exportShareholdersPdf,
        exportShareholderPdf,
        getAdminTransactionHistory,
        getJava300Champions,
        deleteOffer,
        disableOffer,
        enableOffer,
        updateOffer,
        getOffer,
        createOffer,
        getAllOffer,
        getAnalyticsDataUser,
        getJourneySummary,
        getJourneyEvents,
        getJourneyFlows,
        approvedDocumentsUser,
        disapprovedDocumentsUser,
        sendAnnualProgressReportInvestor,
        deleteAnnualProgress,
        addAnnualProgress,
        getAllAnnualProgress,
        generateLink,
        getUserReferral,
        getAdminReferral,
        seenAdminNotificationHistory,
        getAdminNotificationRecieve,
        getUserNotificationDetails,
        getAdminNotification,
        getUserNotification,
        seenNotification,
        adminSendNotification,
        userProfit,
        invest,
        getStore,
        legalForm,
        authLogin,
        investNow,
        getWallet,
        getProfile,
        getAllUser,
        getUserOverviewStats,
        deleteUser,
        adminLogin,
        getAllStore,
        approveUser,
        disableUser,
        enableStore,
        createStore,
        updateStore,
        saveContact,
        getAllStores,
        deleteStores,
        disableStore,
        registration,
        transferShares,
        getTransactions,
        getUserTransactions,
        getAdminUserTransactions,
        getAdminUserProfit,
        generateDividend,
        createSecretAdmin,
        updateUserProfile,
        getTotalUsersCount,
        getAllActiveStores,
        getCountTotalShares,
        getTotalStoresCount,
        investorRegistration,
        getCountAvailableShares,
        legalInvestorRegistration,
        getTotalRecord,
        createManualInvestment,
        getRecentUserInvest,
        getChartData,
        getDividend,
        getAlltransferShares,
        getAllBlogs,
        getOneBlog,
        createBlog,
        deleteBlogs,
        updateBlog,
        disableBlog,
        enableBlog,
        getAllActiveBlog,
        getUserWithdrawl,
        getAllWithdrawl,
        cancelWithdrawl,
        addWithdrawl,
        approvedWithdrawl,
        rejectWithdrawl,
        addNewsFeet,
        getAllNewsFeet,
        getOneBlogById,
        logoutUser,
        kycForm,
        forget,
        updatePassword,
        getUserAllDetails,
        adminInvestUser,
        contactUs,
        addWithdrawlAdmin,
        getAllWithdrawlAdmin,
        resetEmail,
        createOrder,
        verification,
        getUserDocuments,
        submitUserDocuments,
        verifyUserDocuments,
        userKYC,
        submitSignature,
        adminDeleteTransactionUser,
        getAdminProfile,
        getAdminTransactions,
        quoteSharePurchase,
        getShareLots,
        getShareLotReconciliation,
        expireShareReservations,
        getInvestorShareHoldings,
        getInvestorShares,
        getAllPopup,
        getPopupTypes,
        createPopup,
        getPopupbyId,
        UpdatePopup,
        DeletePopup,
        getWorldCupBonusState,
        toggleWorldCupBonus,
        updateUserProfileToken,
        updateAdminProfileToken,
        getSharePriceHistory,
        transferTokens,
        getAlltransferTokens,
        createTicket,
        getAllTickets,
        getTicketById,
        updateTicketById,
        deleteTicketById,
        getSupportConversations,
        getSupportConversation,
        sendSupportMessage,
        updateSupportStatus,
        markSupportRead,
        startSupportConversation,
        deleteSupportConversation,
        bulkDeleteSupportConversations,
        getSupportAttachment,
        getSupportAccessList,
        searchSupportAccessCandidates,
        grantSupportAccess,
        revokeSupportAccess,
        getClaimRequests,
        manageClaimRequest,
        getAdminStats
    };
};

const apis = createBackendServer(Local_URL);

const marketplaceApi = axios.create({
    baseURL: process.env.REACT_APP_MARKETPLACE_API_URL || Local_URL,
    withCredentials: true,
    headers: { Accept: "application/json" },
    timeout: 60 * 1000,
});

marketplaceApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("x-auth-token");
    if (token) {
        config.headers["x-auth-token"] = token;
        config.headers["x-auth-admin"] = "admin";
    }
    return config;
});

marketplaceApi.interceptors.response.use(
    (response) => response,
    (error) => {
        const response = error?.response?.data;
        error.message = response?.message || error.message;
        if (response?.errors) error.errors = response.errors;
        return Promise.reject(error);
    }
);

Object.assign(apis, {
    getMarketplaceAnalytics: (params = {}) => marketplaceApi.get("/api/marketplace/admin/analytics", { params }),
    getSellerPayments: (params = {}) => marketplaceApi.get("/api/marketplace/admin/seller-payments", { params }),
    getSellerPayment: (id) => marketplaceApi.get(`/api/marketplace/admin/seller-payments/${id}`),
    updateSellerPayment: (id, body) => marketplaceApi.patch(`/api/marketplace/admin/seller-payments/${id}`, body),
    retrySellerPaymentEmail: (id) => marketplaceApi.post(`/api/marketplace/admin/seller-payments/${id}/payment-email/retry`),
    getMarketplaceFee: () => marketplaceApi.get("/api/marketplace/admin/fee"),
    updateMarketplaceFee: (body) => marketplaceApi.put("/api/marketplace/admin/fee", body),
    getMarketplaceFeeHistory: (params = {}) => marketplaceApi.get("/api/marketplace/admin/fee/history", { params }),
    getMarketplaceAudit: (params = {}) => marketplaceApi.get("/api/marketplace/admin/audit", { params }),
});

export default apis;
